import { parseCookies } from 'nookies';
import { useEffect, useState } from 'react';

/**
 * Return the value of the cookie identified by `cookieName`.
 * @param {string} cookieName
 * @returns {string} cookieValue
 */
const useCookie = (cookieName) => {
  const [value, setValue] = useState(undefined);
  useEffect(() => {
    setValue(parseCookies()[cookieName]);
  });
  return value;
};

export default useCookie;
